/* eslint-disable class-methods-use-this */
import React from 'react';
import BaseClass from 'components/BaseClass';
import framework from 'utils/framework';
import Happening from 'components/Happening';
import servicePageBindings from 'analytics/bindingMethods/pages/happeningAtSephora/servicesBindings';
import { mediaQueries } from 'style/config';

const { wrapComponent } = framework;

class HappeningPage extends BaseClass {
    componentDidMount() {
        servicePageBindings.setPageLoadAnalytics();
    }

    render() {
        return (
            <div css={styles.wrapper}>
                <Happening />
            </div>
        );
    }
}

const styles = {
    wrapper: {
        [mediaQueries.sm]: {
            minHeight: 'calc(100vh - 300px)'
        }
    }
};

export default wrapComponent(HappeningPage, 'HappeningPage', true);
